import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function PaymentReturn() {
  const { paymentId } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | failed
  const ran = useRef(false);

  const confirm = async () => {
    setState("checking");
    const status = params.get("status") || "success";
    try {
      const { data } = await api.post(`/payments/${paymentId}/confirm-return`, null, { params: { status } });
      if (data.status === "paid") {
        if (data.purpose === "product") {
          navigate("/products", { replace: true });
        } else {
          navigate("/scan", { state: { paymentId }, replace: true });
        }
        return;
      }
      setState("failed");
    } catch {
      setState("failed");
    }
  };

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    confirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-charcoal text-cream">
      <Navbar />
      <div className="mx-auto flex max-w-md flex-col items-center px-6 py-24 text-center">
        {state === "checking" ? (
          <>
            <Loader2 className="mb-6 h-8 w-8 animate-spin text-gold" />
            <h1 className="font-heading text-3xl text-cream">Confirming your payment…</h1>
            <p className="mt-2 text-sm text-muted-foreground">This only takes a moment.</p>
          </>
        ) : (
          <>
            <XCircle className="mb-6 h-10 w-10 text-destructive" />
            <h1 className="font-heading text-3xl text-cream">We couldn't confirm this yet</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              If you completed the payment on iKhokha, tap below to continue — you won't be charged again.
              If you cancelled, you can start over.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <Button className="rounded-full bg-gold text-charcoal hover:bg-gold/90" onClick={confirm} data-testid="continue-after-pay-btn">
                I've paid — continue
              </Button>
              <Button variant="ghost" className="rounded-full border border-charcoal-border text-cream hover:text-gold" onClick={() => navigate("/payment")} data-testid="retry-payment-btn">
                Start over
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
